import { DATA_GRID_DISPLAY_NAME } from "../constants";
import { getClassNameFactory } from "../../../../../utilities";
export var getClassName = getClassNameFactory(DATA_GRID_DISPLAY_NAME);
export var getTypeClassName = function getTypeClassName(type) {
  return getClassName({
    descendantName: "column",
    modifiers: type || "text"
  });
};
export var getRowHeaderClassName = function getRowHeaderClassName() {
  return getClassName({
    descendantName: "column",
    modifiers: "rowHeader"
  });
};